import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import Experience360 from '../../components/Experience360';
import Intro from './Intro';
import { setSetUtmCookies } from '../../helpers/utm';
import { utmCookiesSet } from '../../actions/UI';

import './style.scss';

const CampaignStreet = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    setSetUtmCookies();
    dispatch(utmCookiesSet());
  }, [dispatch]);

  return (
    <>
      <Experience360
        activated
        defaultLat={0}
        defaultLon={180}
        latMin={-25}
        latMax={25}
        animationSmoothing={0.15}
      />
      <Intro />
    </>
  );
};

export default CampaignStreet;
